import { render, staticRenderFns } from "./BABSDetayButon.vue?vue&type=template&id=ab56a1b0&"
import script from "./BABSDetayButon.vue?vue&type=script&lang=js&"
export * from "./BABSDetayButon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports